/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 21 2023
 **/

import { css } from "@emotion/react";

export const popoverStyle = (pos: DesignStuff.MouseOverComp.Position) => css`
	position: fixed;
	z-index: 10;
	${pos}
`;

const positionCSS = (x: number, y: number, zIndex: number) => css`
	top: ${y}px;
	left: ${x}px;
	z-index: ${zIndex};
`;

export const popoverCSS = ({
	position,
	anchorPosition,
	overflow,
	direction,
	hasMouseClickAction,
	zIndex
}: {
	position: { x: number; y: number; width: number; height: number } | null;
	anchorPosition: { x: number; y: number; width: number; height: number };
	overflow: boolean;
	zIndex: number;
	direction?: { x: "center" | "left" | "right"; y: "center" | "top" | "bottom" };
	hasMouseClickAction?: boolean;
}) => css`
	position: fixed;
	${(() => {
		if (!position || !anchorPosition) return positionCSS(document.body.clientWidth, document.body.clientHeight, 0);

		let [top, left] = [anchorPosition.y, anchorPosition.x];

		if (hasMouseClickAction) {
			top -= position.height;
		}

		if (direction && !hasMouseClickAction) {
			switch (direction.x) {
				case "center": {
					left += anchorPosition.width / 2 - position.width / 2;
					break;
				}
				case "left": {
					left += 0;
					break;
				}
				case "right": {
					left += anchorPosition.width;
					break;
				}
			}

			switch (direction.y) {
				case "center": {
					top += anchorPosition.height / 2 - position.height / 2;
					break;
				}
				case "top": {
					top += 0;
					break;
				}
				case "bottom": {
					top += anchorPosition.height;
					break;
				}
			}
		}

		top += position.y;
		left += position.x;

		if (overflow) {
			return positionCSS(left, top, zIndex);
		}
		if (position.width === 0 || position.height === 0) {
			return positionCSS(left, top, zIndex);
		}
		if (left + position.width > document.body.clientWidth) left = document.body.clientWidth - position.width;
		if (top + position.height > document.body.clientHeight) top = document.body.clientHeight - position.height;
		return positionCSS(left, top, zIndex);
	})()};
`;
